import React from 'react';

import withGlobalData from 'components/providers/global-data';

import NotFoundImage from 'static/welcome.svg';

import MainLayout from 'components/templates/main-layout';
import Typography from 'components/common/typography';

import { ImageContainer, Image } from './elements';

const NotFound = ({ user }) => (
  <MainLayout>
    <Typography align="center" lg marginT="30" marginB="50">
      ¡Bienvenid@! {user && user.name}
    </Typography>
    <ImageContainer>
      <Image src={NotFoundImage} />
    </ImageContainer>
  </MainLayout>
);

export default withGlobalData(NotFound);
